import { Component, Input, OnInit, ViewChild } from '@angular/core';
import * as d3 from 'd3';
import { DataBridgeService } from '../../../services/data-bridge.service';

@Component({
  selector: 'app-polygon-factory',
  templateUrl: './polygon-factory.component.html',
  styleUrls: ['./polygon-factory.component.scss']
})
export class PolygonFactoryComponent implements OnInit {

  @Input() svgComponent;
  @Input() data;
  @Input() floorType;
  @Input() layout;
  polygonCount = -1;
  projection: d3.GeoIdentityTransform;
  aspectRatio: number;
  clientToMapWidthRatio: number;
  clientToMapHeightRatio: number;
  pointRadius: number = -1

  constructor(private _dataBridge: DataBridgeService) { }

  ngOnInit() {
    if(this.layout.floorDetails.extras){
      let extras = JSON.parse(this.layout.floorDetails.extras)
      if(extras.pointRadius){
        this.pointRadius = extras.pointRadius
      }
    }
    this.polygonCount = this.data.features.length;
    let doorData = this.getDoorData(this.data);
    this._dataBridge.setAspectRatio(this.data.features[0].geometry.coordinates[0][2]);
    this._dataBridge.calculateClientToMapRatio();
    this.aspectRatio = this._dataBridge.getAspectRatio();
    this.clientToMapWidthRatio = this._dataBridge.getClientToMapWidthRatio();
    this.clientToMapHeightRatio = this._dataBridge.getClientToMapHeightRatio();
    // IF WIDTH RATIO IS GREATER THAN HEIGHT RATIO
    //  THEN FIT HEIGHT ELSE FIT WIDTH
    // REASONING IS THAT WHATEVER RATIO IS SMALLER NEEDS TO FIT ON THE SCREEN TO MAKE THE WHOLE MAP FIT AT ONCE
    if ((this.clientToMapWidthRatio) > (this.clientToMapHeightRatio)) {
        var height = this._dataBridge.getHOST_HEIGHT();
        var width = height * this.aspectRatio;
    }
    else {
        var width = this._dataBridge.getHOST_WIDTH();
        var height = width / this.aspectRatio;
    }
    var svg = d3.select(this.svgComponent)
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("width", width)
        .attr("height", height);
    this.projection = d3.geoIdentity()
        .reflectY(false)
        .fitSize([width, height], this.data);
    var path = d3.geoPath(this.projection);
    this._dataBridge.setSinglePointSize(this.projection([1, 1])[0]);
    if (this.floorType == "WITH_FLOOR_PLAN") {
        let g = svg.selectAll("path").data(this.data.features).enter().append("g");
        g.append("path")
            .attr("d", path)
            .attr("id", function (d, i) {
            return d['properties'].ID + "";
        })
            .style("fill", function (d, i) {
            return "none";
        })
            .style("stroke", function (d, i) {
            return "#000000";
        })
            .style("stroke-width", "0.25px");
        g.select("circle")
            .data(doorData).enter()
            .append("g")
            .attr('type', 'door')
            .append("circle")
            .attr("cx", (d) => { return this.projection(d.location)[0]; })
            .attr("cy", (d) => { return this.projection(d.location)[1]; })
            .attr("r", "1px")
            .attr("fill", "none")
            .attr("angle", function (d, i) { return d.angle; })
            .attr("base", function (d, i) { return d.base; })
            .attr("image", function (d, i) { return d.image; });
            g?.transition().duration(1500)?.style("opacity", "0");
    }
    else if (this.floorType == "WITH_BACKGROUND_IMAGE") {
        let planBorder = svg.selectAll("path").data([this.data.features[0]]).enter().append("g");
        planBorder.append("path")
            .attr("d", path)
            .attr("id", function (d, i) {
            return d['properties'].ID + "";
        })
            .style("fill", function (d, i) {
            return "none";
        })
            .style("stroke", function (d, i) {
            return "#000000";
        });
        let g = svg.selectAll("path").data(this.data.features).enter();
        g.select("circle")
            .data(this.data.features.slice(1)).enter()
            .append("g")
            .attr('type', 'point')
            .append("circle")
            .attr("cx", (d:any) => { return Math.abs(this.projection(d.geometry.coordinates[0][0])[0]); })
            .attr("cy", (d:any) => { return Math.abs(this.projection(d.geometry.coordinates[0][0])[1]); })
            .attr("r", () => {
              if(this.pointRadius > -1) return `${this.pointRadius}px`
              else return (Math.abs(25 * this._dataBridge.getSinglePointSize()) > 4 ? 4 : Math.abs(25 * this._dataBridge.getSinglePointSize())) + 'px';
        })
            .attr("fill", "#000000")
            .attr("id", function (d, i) {
            return d['properties'].ID + "";
        }).style("opacity", '1');
    }
}
  

  addDataToService() {
    this._dataBridge.setSinglePointSize(this.projection([1, 1])[0]);
    this._dataBridge.setAspectRatio(this.aspectRatio);
    this._dataBridge.setClientToMapWidthRatio(this.clientToMapWidthRatio);
    this._dataBridge.setClientToMapHeightRatio(this.clientToMapHeightRatio);
  }

  getDoorData(data: any) {
    let doorData = [];
    data.features.forEach((element, i) => {
      if (element.properties.type == "ROOM" && element.styling?.doorLoc && element.styling?.doorImage) {
        let coordinate
        try{
          coordinate = element.styling.doorLoc?.replaceAll('(', '').replaceAll(')', '').split(',')
        } catch(Exception){
          coordinate = element.styling.doorLoc?.replace(/\(|\)/g, '').split(',');
        }
        coordinate[0] = parseInt(coordinate[0]);
        coordinate[1] = parseInt(coordinate[1]);

        let doorDataObject = {
          angle: element.styling?.doorAngle || 0,
          base: element.styling?.doorBase,
          location: coordinate,
          image: element.styling?.doorImage.trim()
        };

        doorData.push(doorDataObject)
      }
    })
    return doorData
  }
  

}
